import { render, staticRenderFns } from "./PermissionSettings.vue?vue&type=template&id=37f03feb&scoped=true&"
import script from "./PermissionSettings.vue?vue&type=script&lang=js&"
export * from "./PermissionSettings.vue?vue&type=script&lang=js&"
import style0 from "./PermissionSettings.vue?vue&type=style&index=0&id=37f03feb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f03feb",
  null
  
)

export default component.exports